import axiosClient from "utils/api/axios-client";

const categoryApi = {
  getAll: (params) => {
    const url = "/api/v1/categories";
    return axiosClient.get(url, { params });
  },
  get: (id) => {
    const url = `/api/v1/categories/${id}`;
    return axiosClient.get(url);
  },
  create: (category) => {
    const url = `/api/v1/categories/`;
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return axiosClient.post(url, category, config);
  },
  update: (id, category) => {
    const url = `/api/v1/categories/${id}`;
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return axiosClient.put(url, category, config);
  },
  delete: (id) => {
    const url = `/api/v1/categories/${id}`;
    return axiosClient.delete(url);
  },
};

export default categoryApi;
